import { render, staticRenderFns } from "./ReserveServerDialog.vue?vue&type=template&id=0b3e1cea&"
import script from "./ReserveServerDialog.vue?vue&type=script&lang=js&"
export * from "./ReserveServerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports